import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import Loader from "./common/Loader";

/**
 * RoleProtectedRoute - Protects routes based on user roles
 * @param {Array} allowedRoles - Array of role strings that can access this route
 * @param {string} redirectTo - Path to redirect to if user doesn't have access (default: based on role)
 * @param {ReactNode} children - The component to render if access is granted
 */
function RoleProtectedRoute({ allowedRoles = [], redirectTo = null, children }) {
  const { user, userToken, loading, checkAuthLoading } = useSelector(
    (state) => state.user
  );

  if (checkAuthLoading)
    return (
      <h1 style={{ margin: "2rem", textAlign: "center" }}>
        <Loader />
      </h1>
    );
  if (loading) return <Loader />;

  if (!user || !userToken) {
    return <Navigate to={"/login"} />;
  }

  // Get user role - handle both nested and direct structures
  const userRole = user?.roll || user?.role || (user?.user && (user.user.roll || user.user.role));

  // Check if user role is in allowed roles
  const hasAccess = allowedRoles.length === 0 || (userRole && allowedRoles.includes(userRole));

  if (!hasAccess) {
    // Determine redirect path based on user role
    let defaultRedirect = "/login";

    if (userRole === "store") {
      defaultRedirect = "/inventory";
    } else if (userRole === "degitizer") {
      defaultRedirect = "/digitizer-jobcards";
    } else if (userRole === "sampling_digitizer") {
      defaultRedirect = "/sampling-digitizer-jobcards";
    } else if (userRole === "admin" || userRole === "viewer") {
      defaultRedirect = "/";
    } else {
      defaultRedirect = "/jobcard";
    }

    return <Navigate to={redirectTo || defaultRedirect} replace />;
  }

  return <>{children}</>;
}

export default RoleProtectedRoute;

